/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 *  @author    Afternet <info@afternet.gr>
 *  @copyright 2022 Afternet
 *  @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */

const availableLanguages = {
    at: {
        default: 'de',
        // supportedLanguages: ['en', 'de', 'gr'],
        supportedLanguages: ['en', 'gr'],
        switchLanguages: [
            { code : 'en', native : 'EN' },
            // { code : 'de', native : 'DE' },
            { code : 'el', native : 'EL' },
        ]
    },
    de:{
        default: 'en',
        supportedLanguages: ['en', 'el'],
        switchLanguages: [
            { code : 'de', native : 'DE' },
            { code : 'en', native : 'EN' },
        ]
    },
    gr: {
        default: 'el',
        //supportedLanguages: ['el', 'de', 'en'],
        supportedLanguages: ['el', 'en'],
        switchLanguages: [
            { code : 'el', native : 'EL' },
            { code : 'en', native : 'EN' },
            // { code : 'de', native : 'DE' },
        ]
    },
}

export default availableLanguages